<template>
  <div>
    <h2
      class="font-weight-bold mb-4"
    >To increase your chances for approval, please login using your social account</h2>
    <p class="mt-4">If you do not have a social account, you may skip this step.</p>
    <div class="continue">
      <p>Continue with:</p>
      <b-link>
        <img src="@/assets/images/icons/fb.png" alt />
        facebook
      </b-link>
      <b-link>Skip this step</b-link>
    </div>
    <small class="disclaim">By clicking and/or logging-in using my social media account above, I hereby give my consent and authorize Robocash to use said social media account to verify my identity, contact me for the payment of my loan and for all other purpose mentioned in the Privacy Policy of Robocash Finance Corp.</small>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.continue {
  a {
    padding: 5px 20px;
    text-transform: uppercase;
    display: inline-block;
    justify-content: center;
    align-items: center;
    background: #0370d5;
    color: #fff;
    max-width: 230px;
    height: 50px;
    line-height: 40px;
    border-radius: 4px;
    margin-right: 20px;
    text-decoration: none;
    margin-bottom: 15px;
  }
  a:last-child {
    background: $base-color-lightred;
  }
}
.disclaim {
    margin-top: 20px;
    color: #666;
    display: block;
}
</style>